import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            d="M11.42 3.7c2.048.01 3.411 1.239 3.411 4.01 0 3.263-4.652 6.992-6.276 8.194a.915.915 0 0 1-1.102-.002C5.83 14.689 1.17 10.927 1.17 7.709c0-2.488 1.363-4.009 3.415-4.009 1.506 0 2.735 1.29 3.419 2.4.689-1.105 1.926-2.408 3.417-2.4Z"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
